import React, { useState, useEffect } from 'react';
import Navbar from './AdminNav';
import {
  Typography,
  Box,
  Button,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import NotificationDialog from './components/NotificationDialog';
import api from '../api/api';
import { ENDPOINTS } from '../api/endpoints';
import Footer from '../Footer';

const NotificationList = () => {
  const [notifications, setNotifications] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const showToast = (message, severity = 'success') => {
  setSnackbar({ open: true, message, severity });
};
  const [currentNotification, setCurrentNotification] = useState({
    id: 0,
    title: '',
    message: '',
    forRole: '',
    activeFlag: true
  });
  const navigate = useNavigate();
  const [showNotificationDialog, setShowNotificationDialog] = useState(false);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const response = await api.get(ENDPOINTS.getNotificationMessages({ notificationId: 0 }));
      const result = response.data;

      if (result?.status === 'Ok' && Array.isArray(result.data)) {
        const activeNotifications = result.data.filter((n) => n.activeFlag);
        setNotifications(activeNotifications);
      } else {
        console.error('Unexpected API response:', result);
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  const handleDeleteNotification = async (notificationId) => {
    try {
      const payload = {
        id: notificationId,
        title: '',
        message: '',
        forRole: '',
        activeFlag: false
      };

      const response = await api.post(ENDPOINTS.addOrUpdateNotificationMessage(), payload);
      const result = response.data;

      if (result?.status === 'Ok') {
        setNotifications((prev) => prev.filter((n) => n.notificationId !== notificationId));
        setSnackbar({ open: true, message: 'Notification deleted successfully!', severity: 'success' });
      } else {
        setSnackbar({ open: true, message: 'Failed to delete notification.', severity: 'error' });
      }
    } catch (error) {
      console.error('Error deleting notification:', error);
      setSnackbar({ open: true, message: 'Error deleting notification.', severity: 'error' });
    }
  };

  const handleEditNotification = async () => {
    try {
      const payload = { ...currentNotification };

      const response = await api.post(ENDPOINTS.addOrUpdateNotificationMessage(), payload);
      const result = response.data;

      if (result.status === 'Ok') {
        setSnackbar({ open: true, message: 'Notification updated successfully!', severity: 'success' });
        setEditDialogOpen(false);
        fetchNotifications();
      } else {
        console.error('Failed to update notification');
        setSnackbar({ open: true, message: 'Failed to update notification.', severity: 'error' });
      }
    } catch (error) {
      console.error('Error updating notification:', error);
      setSnackbar({ open: true, message: 'Error updating notification.', severity: 'error' });
    }
  };

const handleEditButtonClick = (notification) => {
  console.log("Role from API:", notification.forRole);

  setCurrentNotification({
    id: notification.notificationId,
    title: notification.title,
    message: notification.message,
    forRole: notification.forRole,
    activeFlag: true
  });

  setEditDialogOpen(true);
};

  return (
    <>
      <Navbar />
      <div className="background-prop">
        <div style={{ maxWidth: '1200px', margin: 'auto', padding: '20px', backgroundColor: '#fff' }}>
          <Typography variant="h4" sx={{ mt: 2, mb: 2 }}>
            Notifications List
            <Button
              variant="contained"
              className="nav-link"
              onClick={() => setShowNotificationDialog(true)}
              sx={{ float: 'right' }}
            >
              Add Notification
            </Button>
          </Typography>

          <Box sx={{ mt: 2 }}>
            {notifications.length === 0 ? (
              <Typography>No notifications available.</Typography>
            ) : (
              notifications.map((notification) => (
                <Box
                  key={notification.notificationId}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #dedede',
                    py: 1
                  }}
                >
                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {notification.title}
                    </Typography>
                    <Typography variant="body2">{notification.message}</Typography>
                    <Typography variant="caption">For Role: {notification.forRole}</Typography>
                  </Box>
                  <Box>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => handleEditButtonClick(notification)}
                      sx={{ mr: 1 }}
                    >
                      Edit
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      color="error"
                      onClick={() => handleDeleteNotification(notification.notificationId)}
                    >
                      Delete
                    </Button>
                  </Box>
                </Box>
              ))
            )}
          </Box>
        </div>
      </div>

      {/* Edit Dialog */}
      <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)}>
        <DialogTitle>Edit Notification</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="dense"
            label="Title"
            value={currentNotification.title}
            onChange={(e) => setCurrentNotification({ ...currentNotification, title: e.target.value })}
          />
          <TextField
            fullWidth
            margin="dense"
            label="Message"
            multiline
            rows={3}
            value={currentNotification.message}
            onChange={(e) => setCurrentNotification({ ...currentNotification, message: e.target.value })}
          />
      <FormControl fullWidth margin="dense">
  <InputLabel>For Role</InputLabel>

  <Select
    value={currentNotification.forRole}
    label="For Role"
    onChange={(e) =>
      setCurrentNotification({
        ...currentNotification,
        forRole: e.target.value
      })
    }
  >
    <MenuItem value="Talent">Talent</MenuItem>
    <MenuItem value="Director">Director</MenuItem>
    <MenuItem value="Both">Both</MenuItem>
  </Select>
</FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditDialogOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleEditNotification}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <NotificationDialog
        open={showNotificationDialog}
        onClose={() => setShowNotificationDialog(false)}
        onNotificationAdded={fetchNotifications}
  showToast={showToast}
      />
      <Footer />
    </>
  );
};

export default NotificationList;
